import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon70: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M16.5 12A2.502 2.502 0 0 1 14 9.5c0-.835.415-1.57 1.045-2.024l.999 2.228a.5.5 0 0 0 .66.252c.252-.112.365-.408.252-.66l-1.001-2.233c.176-.039.358-.063.545-.063C17.879 7 19 8.121 19 9.5S17.879 12 16.5 12Zm-5.478-3H8.975a5.501 5.501 0 0 0-2.323-4H8.5a.5.5 0 0 0 .5-.5c0-.827.673-1.5 1.5-1.5h4c.663 0 1.227.433 1.425 1.03a5.417 5.417 0 0 0-1.581.429c-.032.007-.064.008-.094.021-.018.008-.028.023-.044.032A5.504 5.504 0 0 0 11.022 9ZM3.5 12A2.502 2.502 0 0 1 1 9.5C1 8.121 2.121 7 3.5 7c1.208 0 2.217.86 2.449 2H3.5a.5.5 0 0 0 0 1h2.449A2.502 2.502 0 0 1 3.5 12Zm13-6c-.333 0-.649.062-.955.149l-.41-.915A4.473 4.473 0 0 1 16.5 5a.5.5 0 0 0 .5-.5C17 3.121 15.879 2 14.5 2h-.815l-.33-.734A2.036 2.036 0 0 0 11.466 0H10.5a.5.5 0 0 0 0 1h.966c.425 0 .804.254.972.66l.152.34H10.5c-1.207 0-2.218.86-2.45 2H1.5a.5.5 0 0 0 0 1h2c2.311 0 4.197 1.756 4.449 4h-1C6.704 7.309 5.259 6 3.5 6 1.57 6 0 7.57 0 9.5S1.57 13 3.5 13c1.759 0 3.204-1.309 3.449-3H11.5a.5.5 0 0 0 .5-.5c0-1.646.898-3.074 2.223-3.859l.408.911A3.493 3.493 0 0 0 13 9.5c0 1.93 1.57 3.5 3.5 3.5S20 11.43 20 9.5 18.43 6 16.5 6Z"
      />
    </Svg>
  )
}
